/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Meeting_Document_Delete_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo stops reading “{name}”, at the other conversations in this series too. The file itself goes with it." |
*
* @param {Meeting_Document_Delete_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_document_delete_body = /** @type {((inputs: Meeting_Document_Delete_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Document_Delete_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Wundo leest “${i?.name}” dan niet meer mee, ook niet bij de andere gesprekken in deze reeks. Het bestand zelf verdwijnt mee.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Wundo ne lira plus « ${i?.name} », ni pour les autres conversations de cette série. Le fichier lui-même disparaît avec.`)
	return /** @type {LocalizedString} */ (`Wundo stops reading “${i?.name}”, at the other conversations in this series too. The file itself goes with it.`)
});